// extracted by mini-css-extract-plugin
export default {"timeLineGroup":"DOFRContractAssignment_timeLineGroup__vpjQU"};